module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VynhLu/tc-custom/FC-9781398422841.jpg?1692013465634?1725649955848",
      "alt": "This image is the cover for the book Herod's Gold"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Herod's Gold\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The United Nations have been at war with Al-Qaeda in North Africa for many years. The terrorists are determined to reach the valuable gold mines in the south of the country but the UN forces have mostly held them in the vicinity of Timbuktu. Paul Noble, an MI6 officer, is sent to Timbuktu to investigate the mysterious death of an agent named Horace Parker. He draws a blank. In the meantime, his personal interest in gold artefacts leads him to Rome and a meeting with Count Bruno Ravelli, an ambitious politician determined to become the next ‘Caesar’ of Italy. Could there be a connection between the count, Al-Qaeda’s ambitions in the Sahara Desert and gold artefacts stolen by the Romans from King Herod’s temple in Jerusalem in 57 AD? With the MI6, the SAS and MOSSAD hot on the trail, Paul Noble quickly finds himself in a dangerous situation.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Harvey Winchester\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("‘Harvey Winchester’ is the pseudonym of television producer RICHARD BATES, whose many productions include ‘The Darling Buds of May’ and ‘A Touch of Frost’. This is his first novel.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0